import { BookOpen, ExternalLink } from 'lucide-react';
import { PageHeader } from '../features/shared/PageHeader';
import { DocsGuides } from '../features/docs/DocsGuides';
import { ModelAvailabilityPanel } from '../features/docs/ModelAvailabilityPanel';
import { Button } from '../ui';

// Docs page (Ticket W4 — Surface 2). Operator/consumer-facing, behind the existing login.
// Composes: a concise TSX version of the consumer guides (linking out to the full Phoenix-served
// /docs site for the complete reference) + a LIVE "models & providers" availability panel sourced
// from the `docsProviders` query (providers with their modelAliases + current health).

export function DocsPage() {
  return (
    <div>
      <PageHeader
        title="Docs"
        description="How to integrate against the proxy, how to force routing, and what is callable right now."
        breadcrumbs={[{ label: 'Docs' }]}
        actions={
          <Button
            variant="secondary"
            onClick={() => window.open('/docs/index.html', '_blank', 'noopener')}
            leftIcon={<BookOpen className="h-4 w-4" aria-hidden="true" />}
          >
            Full reference
          </Button>
        }
      />

      <section aria-labelledby="guides-heading" className="mb-10">
        <div className="mb-4 flex items-center justify-between gap-3">
          <h2 id="guides-heading" className="sr-only">
            Consumer guides
          </h2>
        </div>
        <DocsGuides />
        <p className="mt-4 text-sm">
          <a
            href="/docs/api-reference.html"
            className="inline-flex items-center gap-1.5 font-medium text-indigo-500 hover:text-indigo-400"
          >
            Open the full OpenAPI reference
            <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
          </a>
        </p>
      </section>

      <ModelAvailabilityPanel />
    </div>
  );
}
